<template>
	<div>
		<Layout>
			<div class="container box_general" v-if="!loading">
				<div class="header_box">
					<h2><i class="pe-7s-user"></i>Mi perfil</h2>
				</div>
				<div class="row">
					<div class="col">
						<div class="mt-4 mb-2">
							<div class="header_box">
								<h3>Datos personales</h3>
								<router-link tag="a" class="btn btn-xs btn-link mt-1" to="/profile/update">Modificar</router-link>
							</div>
							<table class="table table-borderless table-right-titles table-sm table-first-30">
								<tr>
									<td>Nombre y apellido</td>
									<td>{{ item.name }} {{ item.lastname }}</td>
								</tr>
								<tr>
									<td>Razón social</td>
									<td>{{ item.businessName }}</td>
								</tr>
								<tr>
									<td>RUT</td>
									<td>{{ item.rut }}</td>
								</tr>
								<tr>
									<td>Dirección técnica</td>
									<td>{{ item.managerName }} {{ item.managerLastname }} - CJP: {{ item.managerCJP }}</td>
								</tr>

								<tr>
									<td>Teléfono</td>
									<td>
										<span v-if="item.phone">
											{{ item.phone.international }}
										</span>
									</td>
								</tr>
								<tr>
									<td>Dirección</td>
									<td>
										<span v-if="item.address">
											{{ item.address.street }} {{ item.address.number }} <br />
											<small v-if="item.address.comments">{{ item.address.comments }}<br></small>
											<small v-if="item.address.locality"> {{ item.address.locality.name }}, {{ item.address.locality.region.name }}</small> 
										</span>
										<small v-else>
											<strong>Edita tu perfil para agregar tu dirección</strong>
										</small>
									</td>
								</tr>
							</table>
						</div>

						<br />
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import { mapGetters } from "vuex"

import Layout from "@/components/layout/Layout"

export default {
	name: "Settings",
	metaInfo: {
		title: "Configuración"
	},
	components: {
		Layout
	},
	computed: {
		...mapGetters(["isAuthenticated", "loggedPharmacy"])
	},
	data() {
		return {
			item: {},
			validationErrors: {},
			loading: true
		}
	},
	methods: {
		deleteAddressConfirm(id) {
			this.$dialog.confirm("¿Está seguro que desea eliminar esta dirección?").then(() => {
				this.deleteAddress(id)
			})
		},
		deleteAddress(id) {
			this.validationErrors = {}
			let error = false
			if (this.item.medicBusinessAddresses.length <= 1) {
				this.$toast.error("No se puede eliminar, debes tener al menos una dirección ingresada")
				error = true
			}

			if (!error && !this.loading) {
				this.loading = true
				this.$apollo
					.mutate({
						mutation: gql`
							mutation($id: ID!) {
								medicBusinessAddressDelete(id: $id) {
									id
								}
							}
						`,
						variables: {
							id: id
						}
					})
					.then(() => {
						this.$toast.success("Dirección eliminada correctamente")
						this.loading = false
						this.$apollo.queries.meitem.refetch()
						this.hasChanges = false
					})
					.catch(error => {
						this.$toast.error("Error al eliminar la dirección!")
						let { graphQLErrors } = error
						if (graphQLErrors[0].extensions.category === "validation") {
							this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation)
						} else {
							this.validationErrors["general"] = "Se ha producido un error"
						}
						this.loading = false
					})
			}
		}
	},
	apollo: {
		mePharmacy: {
			query: gql`
				query {
					pharmacyLogged {
						id
						name
						businessName
						email
						rut
						managerName
						managerLastname
						managerCJP
						phone {
							national
							international
						}

						address {
							country {
								id
								name
							}
							locality{
								id name
								region { id name}
							}
							street
							number
							comments
						}
					}
				}
			`,
			fetchPolicy: "no-cache",
			result({ data }) {
				this.item = data.pharmacyLogged
				this.loading = false
			}
		}
	}
}
</script>

<style scoped></style>
